var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"flex min-h-screen"},[_c('left-nav'),_c('div',{staticClass:"flex flex-col w-full"},[_c('top-nav'),_c('router-view')],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }